import "./LoginBoxNotLoggedIn.scss";
import React from "react";
import { useTranslation } from "react-i18next";
import { Dialog } from "spot-component-library/src/components/basic/dialog/Dialog";
import debtNumberImageCH from "../../../resources/images/Anschreiben_Forderungsnummer_CH.svg";
import debtNumberImageFR from "../../../resources/images/where_is_my_debt_number_fr.svg";
import { LoginDebtId } from "../loginDebtId/LoginDebtId";
import { useTenant } from "../../contexts/TenantContext";
import { TenantName } from "../../types/TenantName";

export const LoginBoxNotLoggedIn: React.FC = (props) => {
    const { t } = useTranslation();
    const tenant = useTenant();
    const debtNumberImage = getDebtNumberImage(tenant?.name);

    return (
        <div id="noLogin">
            <h2>
                {t("LOGIN_BOX.NO_LOGIN.HEADLINE1")}
                <Dialog closeIcon={true} triggerIcon="icon-questions-V2" dialogStyle={{ maxWidth: "600px", width: "85%" }}>
                    {t("LOGIN_BOX.NO_LOGIN.DIALOG_HEADLINE")}
                    <img src={debtNumberImage} alt={""} className={"debt-number-image"} />
                </Dialog>
                {t("LOGIN_BOX.NO_LOGIN.HEADLINE2")}
            </h2>

            <p>{t("LOGIN_BOX.NO_LOGIN.TEXT")}</p>
            <LoginDebtId buttonText={t("LOGIN_BOX.NO_LOGIN.BUTTON")} buttonPosition={"Right"} />
        </div>
    );
};

export function getDebtNumberImage(tenant: TenantName | undefined) {
    switch (tenant) {
        case "ch-eos":
            return debtNumberImageCH;
            break;
        case "fr-eos":
            return debtNumberImageFR;
            break;
        default:
            return debtNumberImageCH;
            break;
    }
}
